import Section from '../../../../components/ui/Section'

<Section id='privacy' title='Privacy Policy' subtitle='Effective date: 2026-03-01' centered background='dark'>

<div style={{ 
  maxWidth: '900px', 
  margin: '0 auto', 
  textAlign: 'left', 
  padding: '0 2rem',
  fontSize: '1.05rem',
  lineHeight: '1.8'
}}>

CloudSoft Marcin Malinowski ("we," "our," "us") respects your privacy and is committed to protecting your personal data. This Privacy Policy explains how we collect, use, disclose and safeguard your information when you visit our website, https://www.cloudsoft.com.pl/ ("Website").

## 1. Information We Collect

We may collect and process the following types of information:

- **Personal Data**: Name, email address, phone number, company name, or any other information you provide via communications.
- **Technical Data**: IP address, browser type, device information, operating system and browsing behavior collected via cookies or analytics tools.
- **Usage Data**: Information about how you use our Website, including page views, time spent on pages and referral sources.

## 2. How We Use Your Information

We use your information to:

- Provide, operate and maintain our Website.
- Respond to inquiries and provide customer support.
- Improve our Website, services and user experience.
- Analyze user behavior and Website traffic.
- Comply with legal obligations and protect our rights.

## 3. Sharing Your Information

We do not sell or rent your personal data. However, we may share your information with:

- **Service Providers**: Third-party vendors that assist us in Website maintenance, analytics and marketing.
- **Legal Authorities**: When required by law or to protect our legal rights.

## 4. Cookies and Tracking Technologies

Our Website uses cookies and similar technologies to improve user experience. You can manage cookie preferences through your browser settings.

## 5. Data Security

We implement security measures to protect your data, but no method of transmission over the internet is 100% secure. We encourage you to use strong passwords and keep your information safe.

## 6. Your Rights

You have the right to:

- Access, correct, or delete your personal data.
- Withdraw consent for data processing.
- Object to data collection and processing in certain circumstances.

To exercise these rights, contact us at [contact@cloudsoft.com.pl](mailto:contact@cloudsoft.com.pl).

## 7. Third-Party Links

Our Website may contain links to third-party sites. We are not responsible for their privacy policies or content.

## 8. Changes to This Privacy Policy

We may update this policy from time to time. Changes will be posted on this page with an updated effective date.

## 9. Contact Us

For any questions regarding this Privacy Policy, please contact us at:

**CloudSoft Marcin Malinowski**  
[contact@cloudsoft.com.pl](mailto:contact@cloudsoft.com.pl)

</div>

</Section>
